export default "__VITE_ASSET__CboLw8Pd__"